import { useMutation, useQuery, useQueryClient } from 'react-query';
import { queryCreate, queryGet, queryUpdate } from './fetch';
import { AxiosError } from 'axios';

export enum CSMRecommendationType {
  WARN = 'WARN',
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export interface CSMRecommendation {
  id: string;
  sessionId: string;
  message: string;
  clientReadMessage: boolean;
  type: CSMRecommendationType;
  createdAt: Date;
}

interface createDto {
  sessionId: string;
  message: string;
  type: CSMRecommendationType;
}

export const useCreateCSMRecommendation = (sessionId?: string) => {
  const queryClient = useQueryClient();
  return useMutation<CSMRecommendation, AxiosError, createDto>(
    (dto: createDto) =>
      queryCreate(`/sessions/${dto.sessionId}/csm-recommendations`)(dto),
    {
      onSuccess: () => {
        setTimeout(() => {
          queryClient.invalidateQueries(['sessions', sessionId, 'history']);
          queryClient.invalidateQueries([
            'sessions',
            sessionId,
            'csm-recommendations',
          ]);
        }, 500);
      },
    },
  );
};

export const useCSMRecommendations = (sessionId?: string) => {
  return useQuery<CSMRecommendation[]>(
    ['sessions', sessionId, 'csm-recommendations'],
    queryGet(`/sessions/${sessionId}/csm-recommendations`),
    {
      enabled: !!sessionId,
    },
  );
};

export const useReadCSMRecommendation = (sessionId?: string) => {
  const queryClient = useQueryClient();
  return useMutation<CSMRecommendation, AxiosError, { id: string }>(
    ({ id }) => queryUpdate(`/csm-recommendations/${id}/read`)({}),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries([
          'sessions',
          sessionId,
          'csm-recommendations',
        ]);
      },
    },
  );
};
